// @flow

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';

export default class PasswordInput extends Component {

  static propTypes = {
    value: PropTypes.string,
    optionDisplayPassword: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func,
    className: PropTypes.string,
    placeholder: PropTypes.string,
    error: PropTypes.bool,
  };

  static defaultProps = {
    value: '',
    optionDisplayPassword: true,
    onBlur: () => {},
    className: null,
    placeholder: '',
    error: false,
  };

  state = {
    isVisible: false
  };

  onIconClicked = () => {
    if (this.props.optionDisplayPassword === true) {
      this.setState({
        isVisible: !this.state.isVisible
      });
    }
  };

  // -- renderers

  renderIcon() {
    if (this.props.optionDisplayPassword === false) {
      return (
        <i className="fa fa-lock" />
      );
    }

    if (this.state.isVisible) {
      return (
        <i className="fa fa-eye-slash" />
      );
    }

    return (
      <i className="fa fa-eye" />
    );
  }

  render() {
    const className = classNames('password_input', this.props.className);
    const type = this.state.isVisible ? 'text' : 'password';
    const classNameinput = classNames('form-control', {error: this.props.error});

    return (
      <div className={className}>
        <input
          type={type}
          className={classNameinput}
          placeholder={this.props.placeholder}
          value={this.props.value}
          onChange={(event) => { this.props.onChange(event.target.value); }}
          onBlur={this.props.onBlur}
          autoComplete={this.props.autoComplete}
        />
        <div
          className="input-group-addon pointer"
          onClick={this.onIconClicked}
        >
          {this.renderIcon()}
        </div>
      </div>
    );
  }
}
